import {getUrl} from "utils/http";
import {endpoints} from "services/_endpoints";

export const getTemplates = (): Promise<any> => {
  return getUrl(`${endpoints.templates}/OpenResume`);
}